import { motion } from "motion/react";
import { Link } from "react-router-dom";
import { BarChart3, Zap, DollarSign, Users, Cloud, ArrowRight } from "lucide-react";

export function SolucoesPage() {
  const solutions = [
    {
      icon: BarChart3,
      title: "AgroindERP",
      desc: "Plataforma completa de gestão empresarial para agroindústria",
      features: ["Gestão integrada", "Multi-empresa", "Cloud 100%", "Acesso mobile"],
      gradient: "from-green-500 to-green-600"
    },
    {
      icon: DollarSign,
      title: "Gestão Financeira",
      desc: "Controle total do financeiro com visão em tempo real",
      features: ["Contas a pagar/receber", "Fluxo de caixa", "Conciliação bancária", "DRE automático"],
      gradient: "from-blue-500 to-blue-600"
    },
    {
      icon: Users,
      title: "CRM Comercial",
      desc: "Gestão completa de vendas e relacionamento com clientes",
      features: ["Pipeline de vendas", "Histórico completo", "Gestão de propostas", "Metas e comissões"],
      gradient: "from-purple-500 to-purple-600"
    },
    {
      icon: BarChart3,
      title: "Business Intelligence",
      desc: "Indicadores e dashboards em tempo real para decisões assertivas",
      features: ["Dashboards executivos", "Relatórios gerenciais", "Análises personalizadas", "Indicadores em tempo real"],
      gradient: "from-indigo-500 to-indigo-600"
    },
    {
      icon: Zap,
      title: "Gestão Industrial",
      desc: "Controle completo da produção e operações industriais",
      features: ["Controle de produção", "Gestão de estoque", "Rastreabilidade", "Qualidade e conformidade"],
      gradient: "from-orange-500 to-orange-600"
    },
    {
      icon: Cloud,
      title: "Integrações Empresariais",
      desc: "Conexão com principais soluções financeiras e industriais do mercado",
      features: ["Bancos e operadoras", "Sistemas fiscais", "Plataformas logísticas", "Soluções corporativas"],
      gradient: "from-cyan-500 to-cyan-600"
    },
  ];

  return (
    <div className="min-h-screen bg-white pt-20">
      <section className="py-24 px-6 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Soluções completas para<br />
              <span className="bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
                gestão empresarial
              </span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Produtos integrados que transformam operações complexas em processos inteligentes e automatizados
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {solutions.map((solution, index) => (
              <motion.div
                key={index}
                className="group bg-white rounded-3xl p-8 shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-100"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -8 }}
              >
                <div className={`w-16 h-16 bg-gradient-to-br ${solution.gradient} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg`}>
                  <solution.icon className="w-8 h-8 text-white" />
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-3">{solution.title}</h3>
                <p className="text-gray-600 mb-6">{solution.desc}</p>

                <ul className="space-y-3 mb-6">
                  {solution.features.map((feature, i) => (
                    <li key={i} className="flex items-center gap-2 text-gray-700">
                      <div className={`w-1.5 h-1.5 rounded-full bg-gradient-to-r ${solution.gradient}`}></div>
                      {feature}
                    </li>
                  ))}
                </ul>

                <button className="text-green-600 font-medium flex items-center gap-2 group-hover:gap-3 transition-all">
                  Saiba mais
                  <ArrowRight className="w-4 h-4" />
                </button>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 px-6 bg-gradient-to-br from-green-600 to-blue-700">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Veja as soluções em ação
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Agende uma demonstração personalizada para seu segmento
          </p>
          <Link to="/demonstracao">
            <motion.button
              className="px-8 py-4 bg-white text-green-700 rounded-xl hover:shadow-2xl transition-all font-medium"
              whileHover={{ scale: 1.05 }}
            >
              Solicitar demonstração
            </motion.button>
          </Link>
        </div>
      </section>
    </div>
  );
}
